// @ts-ignore - Volto core export, no .d.ts
import { searchContent } from '@plone/volto/actions/search/search';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

// Folder mode shows the images that sit directly in a folder or a page.
// An empty folder field means the page that holds the block. The root of
// the site has the path ''.
export const folderPath = (data: any, content: any): string | undefined => {
  if (data?.mode === 'selection') return undefined;
  const picked = Array.isArray(data?.folder)
    ? data.folder[0]?.['@id']
    : undefined;
  const id: string | undefined = picked || content?.['@id'];
  return id === undefined ? undefined : flattenToAppURL(id);
};

export const subrequestKey = (blockId: string) => `gallery-${blockId}`;

export const searchFolderImages = (path: string, blockId: string) =>
  searchContent(
    path,
    {
      portal_type: 'Image',
      'path.depth': 1,
      sort_on: 'getObjPositionInParent',
      b_size: 1000,
      metadata_fields: ['description'],
    },
    subrequestKey(blockId),
  );

// Volto calls this during server rendering, so the page holds the images.
export const getAsyncData = ({ dispatch, id, data, content }: any) => {
  const path = folderPath(data, content);
  return [
    path === undefined
      ? Promise.resolve(null)
      : dispatch(searchFolderImages(path, id)),
  ];
};
